module.exports = __webpack_public_path__ + "static/media/border-header.f9bad706.svg";